import { PrimaryTag } from '@msrceng/component';
import { useTranslation } from 'react-i18next';
import { isDateNewerThanXMonthsAgo } from 'util/date/isDateNewerThanXMonthsAgo';

/**
 * UI for rendering a "Recently updated!" tag for items that are newer than 1 month.
 */
export const RecentlyUpdatedTag = ({
  date,
  revisionLength,
}: {
  date: Date | string | undefined;
  revisionLength: number;
}) => {
  const [t] = useTranslation(['search']);

  const isRecentlyUpdated = isDateNewerThanXMonthsAgo(date, 1);

  if (!isRecentlyUpdated || revisionLength < 2) {
    return null;
  }
  return (
    <PrimaryTag
      styles={{
        root: {
          whiteSpace: 'nowrap',
        },
      }}
    >
      {t('recentlyUpdated', {
        defaultValue: 'Recently updated!',
        ns: 'search',
      })}
    </PrimaryTag>
  );
};
